import { IRoute } from "../../../common/helpers/routesMapper";
import { seo } from "../../../common/helpers/seo";
import { Store } from "redux";

import lazyComponent from "./lazy";

export default {
    component: lazyComponent,
    renderSeo: (store: Store, allMessage: {[key: string]: string}, lang: string) => {
        return seo({ title: allMessage["homework.completed.title"], allMessage, lang });
    },
} satisfies IRoute;
